import { EventEmitter, Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Observable } from 'rxjs';
import { CommonConstant } from '../constants/common.constant';
import { ApiModulesService } from '../services/api-modules.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {

  private count = 0;
  private spinner$ = new BehaviorSubject<string>('');

  constructor(private router: Router,private toastr: ToastrService,private apiModulesService: ApiModulesService) { }

  getSpinnerObserver(): Observable<string> {
    return this.spinner$.asObservable();
  }

  requestStarted() {
    if (++this.count === 1) {
      this.spinner$.next('start');
    }
  }

  requestEnded() {
    if (this.count === 0 || --this.count === 0) {
      this.spinner$.next('stop');
    }
  }

  resetSpinner() {
    this.count = 0;
    this.spinner$.next('stop');
  }
  dataemitterr = new EventEmitter<any>();
  raiseDataEmitterEvent(data: any) {
    this.dataemitterr.next(data);
  }
  toasterError(err) {
    this.raiseDataEmitterEvent('off')
    if (err.status == 401) {
      let params: any = {}
      params.token = localStorage.getItem('token');
      this.apiModulesService.list('logout', params).subscribe();
      window.localStorage.removeItem('token');
      window.localStorage.removeItem('is_first_login');
      window.localStorage.clear();

      ($('#logout_pop_up') as any).modal('hide');
      this.router.navigateByUrl("/login");
      return;
    }
    let errorsData = err.error.data;
    let firstKey = Object.keys(errorsData)[0];  // Getting the first key
    let errors = errorsData[firstKey];      // Getting the value for the first key

    errors = errors.replace('SQLSTATE[42000]: [Microsoft][ODBC Driver 17 for SQL Server][SQL Server]', 'Error: ')
    errors = errors.replace('SQLSTATE[42000]: [Microsoft][ODBC Driver 18 for SQL Server][SQL Server]', 'Error: ')
    this.toastr.error(errors, 'TryAgain');
  }
  leaveapplyemitterr = new EventEmitter<any>();
  //   dataemitterr= new Subject<any>();
  compOffEmitterEvent(data: any) {
    this.leaveapplyemitterr.next(data);
  }
  getSeverity(status: string) {
    switch (status.toLowerCase()) {
      case 'inactive':
        return 'danger';

      case 'active':
        return 'success';
    }
  }
  getAcronym(str: any) {
    var matches = str.match(/\b(\w)/g); // ['J','S','O','N']
    matches = matches.slice(0, 2);
    var acronym = matches.join(''); // JSON
    return acronym;
  }
  getBgColors(str: any) {
    var min = 0;
    var max = 15;
    var index = this.findAlphapositions(str, 1);
    return CommonConstant.nameBgColors[index];
  }
  findAlphapositions(str: any, n: any) {
    var NUM = 31;

    return str[0].charCodeAt(0) & NUM;
  }

  callStatusModel(url_name: any, data: any) {
    var statusApi = url_name;
    var statusValue = data;
  }
}
